var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c("v-parallax", {
        staticClass: "hidden-sm-and-down",
        attrs: { src: "/static/images/about_us_banner.jpg", height: "400" }
      }),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { "d-flex": "", xs12: "" } },
        [
          _c(
            "v-container",
            { staticClass: "text-xs-center title1  display-2" },
            [_vm._v("About Us")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { "d-flex": "", xs12: "" } },
        [
          _c("v-container", { staticClass: " title2" }, [
            _c("b", [_vm._v("ShareYourselfArtists.com")]),
            _vm._v(
              " connects visual artists to the art pages and sites that are making internet artists famous all around the world. \n      "
            ),
            _c("b", [_vm._v("Share Yourself Artists")]),
            _vm._v(
              " makes the submission process simple and fun! We have helped hundreds of artists get recognition for their artwork. We are also the only submission platform that helps art pages earn money for maintaining their blog. By using our site, you are supporting the online arts industry!\n    "
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { "d-flex": "", xs12: "", "child-flex": "" } },
        [
          _c("v-container", { staticClass: " title2" }, [
            _c("h2", [_vm._v("Nick McElmurry")]),
            _c("br"),
            _vm._v(" "),
            _c("span", { staticClass: "font-weight-thin" }, [
              _c("em", [_vm._v("(Founder/Chief Executive Officer)")]),
              _c("br")
            ]),
            _vm._v(
              "Nick's business and marketing expertise derive from both his work experiences and his personal endeavors. He has worked as a marketing executive for companies including, but not limited to, Jamba Juice, Sunpower, and State Farm. Though his specialty is social media and internet marketing, for he has accumulated over 100,000 followers across his personal project pages, Nick also has experience throwing and organizing events."
            ),
            _c("a", { attrs: { href: "https://battleofthebaybands.com/" } }, [
              _vm._v(" He founded Battle of The Bay (Bands) ")
            ]),
            _vm._v(
              " in 2018, a competition including over 30 bands from 5 different cities. \n        He also has a soft spot for the arts industry.  He is a musician in many different bands, but is most known for his band "
            ),
            _c(
              "a",
              { attrs: { href: "https://soundcloud.com/water-color-weekend" } },
              [_vm._v("Water Color Weekend.")]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { "d-flex": "", xs12: "" } },
        [
          _c("v-container", { staticClass: " title2" }, [
            _c("h2", [_vm._v("Scott Davis")]),
            _c("br"),
            _vm._v(" "),
            _c("span", { staticClass: "font-weight-thin" }, [
              _c("em", [_vm._v("(Software Engineer)")]),
              _c("br")
            ]),
            _vm._v(
              "Scott handles much of our development work and other stuff. As our Chief Creative/Developer, he's responsible for the overall work product of the company, overseeing our Design & Development. In the rare event that he's not working, he spends as much time as possible with his wife and his daughter. While he does occasionally get some sleep, it's usually when he passes out in his chair while working through the middle of the night.\n      "
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe0057cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe0057cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/about_us.vue
// module id = null
// module chunks = 